import React, { useEffect, useState } from 'react';
import { Banner, ErpIntegrationProviderIdResource } from 'Shared/util/types';
import { generateSsoLink } from 'Shared/util/web-api';
import { useTranslation } from 'Shared/util/custom-hooks';
import BaseBanner from 'Shared/components/banners/base-banner';
import Description from 'Shared/components/description';
import InlineSvg from 'Shared/components/inline-svg';
import Button from 'Shared/components/button';
import styles from './acconomy-reminder-banner.css';


type AcconomyReminderBannerProps = {
  numberOfInvoices: number;
};

const AcconomyReminderBanner = ({
  numberOfInvoices,
}: AcconomyReminderBannerProps) => {
  const [ssoLink, setSsoLink] = useState<string>();
  const t = useTranslation(x => x.acconomy);
  const tg = useTranslation(x => x.global);

  useEffect(() => {
    /* NOTE: React might show an incorrect error ("Warning: Can't perform a React state update on an unmounted component...") if component
    have been unmounted on "setState". This should be fixed in upcoming release https://github.com/facebook/react/pull/22114 */
    generateSsoLink({ path: 'invoices', providerId: ErpIntegrationProviderIdResource.Acconomy })
      .then((result) => setSsoLink(result));
  }, []);

  const handleButtonClick = () => window.open(ssoLink);

  return (
    <BaseBanner
      id={Banner.UseIntegrationReminderAcconomy}
      render={() => (
        <div className={styles.container}>
          <div className={styles.titleContainer}>
            <h2>{t.simplifyYourInvoiceFlowBetweenMyPages}</h2>
            <InlineSvg src="/integration/acconomy.svg" className={styles.svgContainer} />
          </div>
          <Description
            text={t.format(t.youHaveRecentlySentInvoicesViaEmail, {
              numberOfInvoices1: numberOfInvoices,
              numberOfInvoices2: (numberOfInvoices > 1 ? tg.invoicesPlural : tg.invoicesSingular)
            })}
            className={styles.description}
          />
          <Button
            className={styles.button}
            buttonType="action-primary"
            text={t.go_to_acconomy}
            onClick={handleButtonClick}
            attributes={{ disabled: !ssoLink }}
          />
        </div>
      )}
    />
  );
};

export default AcconomyReminderBanner;
